__turbopack_context__.v({
  "freeBox___3An8Z": "PlasmicReview-module__id7o4G__freeBox___3An8Z",
  "freeBox___6VFCw": "PlasmicReview-module__id7o4G__freeBox___6VFCw",
  "freeBox__kbHe": "PlasmicReview-module__id7o4G__freeBox__kbHe",
  "freeBox__vqesv": "PlasmicReview-module__id7o4G__freeBox__vqesv",
  "img__isqo9": "PlasmicReview-module__id7o4G__img__isqo9",
  "root": "PlasmicReview-module__id7o4G__root",
  "slotTargetChildren": "PlasmicReview-module__id7o4G__slotTargetChildren",
  "slotTargetSlot2": "PlasmicReview-module__id7o4G__slotTargetSlot2",
  "svg__maPbt": "PlasmicReview-module__id7o4G__svg__maPbt",
  "svg__xo1P": "PlasmicReview-module__id7o4G__svg__xo1P",
  "svg__xp6T4": "PlasmicReview-module__id7o4G__svg__xp6T4",
  "svg__yUjG7": "PlasmicReview-module__id7o4G__svg__yUjG7",
  "svg__yZnxo": "PlasmicReview-module__id7o4G__svg__yZnxo",
});
